import React from 'react';
import { Navigate } from 'react-router';

import { GameDetails } from '@app/dev/terminal/components/casinoAndLiveCasinoViewer/components/gameDetails';
import ClientTransactionLayout from '@app/dev/terminal/containers/clientTransaction/components/layout';
import ClientTransactionWithdraw from '@app/dev/terminal/containers/clientTransaction/withdraw';
import ClientTransactionDeposit from '@app/dev/terminal/containers/clientTransaction/deposit';
import TournamentDetails from '@app/dev/terminal/containers/tournaments/components/details';
import ErrorNotFoundPage from '@app/dev/terminal/components/errorNotFoundPage';
import ClientTransaction from '@app/dev/terminal/containers/clientTransaction';
import { LiveCasinoWrapper } from '@app/dev/terminal/containers/liveCasino';
import TicketsWrapper from '@app/dev/terminal/containers/ticketsWrapper';
import ThirdPartyGame from '@app/dev/terminal/containers/thirdPartyGame';
import AdminWrapper from '@app/dev/terminal/containers/adminWrapper';
import { CasinoWrapper } from '@app/dev/terminal/containers/casino';
import Tournaments from '@app/dev/terminal/containers/tournaments';
import BetHistory from '@app/dev/terminal/containers/bethistory';
import RacingDetails from '@racings/components/racingDetails';
import RacingFutureSpecialDetails from '@racings/components/racingDetails/racingFutureSpecialDetails';
import Prematch from '@app/dev/terminal/containers/prematch';
import Results from '@app/dev/terminal/containers/results';
import { RacingsLayout } from '@racings/components/layout';
import Layout from '@app/dev/terminal/containers/layout';
import RacingMain from '@racings/components/racingMain';
import RacingResultMain from '@racings/result/components/racingResultMain';
import RacingResultDetails from '@racings/result/components/racingResultDetails';
import Home from '@app/dev/terminal/containers/home';
import Live from '@app/dev/terminal/containers/live';
import Config from '@skin_config';
import BettingLayout from '@app/dev/terminal/containers/bettingLayout';
import { CustomCasinoProvider } from '@app/dev/terminal/components/customCasinoProvider';
import { CustomCasinoCategory } from '@app/dev/terminal/components/customCasinoCategory';
import VirtualsResults from '../../../terminal/containers/virtualsResults';

export const routeDefinitions = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: Config.main.terminalMode === 'clientTransaction'
          ? <Navigate to="/clientTransaction" />
          : Config.main.defaultRoute === '/' ? <Home />
            : <Navigate to={`${Config.main.defaultRoute}`} />,
      },
      {
        path: 'bethistory',
        children: [{ index: true, element: <BetHistory /> }],
      },
      {
        path: 'betting',
        element: <BettingLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/betting/prematch/all" />,
          },
          {
            path: 'results',
            children: [{ index: true, element: <Results /> }],
          },
          {
            path: 'racings/:sportType?',
            element: <RacingsLayout routePrefix="/betting" />,
            children: [
              {
                path: 'upComing/:regionAlias?/',
                index: true,
                element: <RacingMain routePrefix="/betting" />,
              },
              {
                path: 'upComing/:regionAlias/:compId?/:gameId?',
                index: true,
                element: <RacingDetails routePrefix="/betting" />,
              },
              {
                path: 'upComing/:regionAlias/:compId?/:gameId?/special_futures',
                index: true,
                element: <RacingFutureSpecialDetails routePrefix="/betting" />,
              },
              {
                path: 'result/:regionAlias?/',
                index: true,
                element: <RacingResultMain routePrefix="/betting" />,
              },
              {
                path: 'result/:regionAlias/:compId?/:matchId?',
                index: true,
                element: <RacingResultDetails routePrefix="/betting" />,
              },
            ],
          },
          {
            path: 'virtual-results',
            element: <VirtualsResults />,
          },
          {
            path: 'prematch/:listType?/:sportAlias?/:regionAlias?/:competitionId?/:gameId?',
            element: <Prematch />,
          },
          {
            path: 'live/:listType?/:sportAlias?/:regionAlias?/:competitionId?/:gameId?',
            element: <Live />,
          },
        ],
      },
      {
        path: 'virtuals/results',
        element: <VirtualsResults />,
      },
      // {
      //   path: 'racings/:sportType?',
      //   element: <RacingsLayout />,
      //   children: [
      //     {
      //       path: 'upComing/:regionAlias?/',
      //       index: true,
      //       element: <RacingMain />,
      //     },
      //     {
      //       path: 'upComing/:regionAlias/:compId?/:gameId?',
      //       index: true,
      //       element: <RacingDetails />,
      //     },
      //     {
      //       path: 'upComing/:regionAlias/:compId?/:gameId?/special_futures',
      //       index: true,
      //       element: <RacingFutureSpecialDetails />,
      //     },
      //     {
      //       path: 'result/:regionAlias?/',
      //       index: true,
      //       element: <RacingResultMain />,
      //     },
      //     {
      //       path: 'result/:regionAlias/:compId?/:matchId?',
      //       index: true,
      //       element: <RacingResultDetails />,
      //     },
      //   ],
      // },
      {
        path: 'tickets',
        children: [{ index: true, element: <TicketsWrapper /> }],
      },
      {
        path: 'casino-game',
        children: [
          { index: true, element: <GameDetails /> },
          { path: ':id', element: <GameDetails isFullScreenGame /> },
        ],
      },
      {
        path: 'casino-provider/*',
        children: [
          // { index: true, element: <CustomCasinoProvider /> },
          {
            element: <CustomCasinoProvider />,
            children: [
              { path: ':providerId', element: <CustomCasinoProvider /> },
              { path: ':providerId?/:gameId', element: <GameDetails /> },
            ],
          },
        ],
      },
      {
        path: 'casino-category/*',
        children: [
          // { index: true, element: <CustomCasinoProvider /> },
          {
            element: <CustomCasinoCategory />,
            children: [
              { path: ':categoryId', element: <CustomCasinoCategory /> },
              { path: ':categoryId?/:gameId', element: <GameDetails /> },
            ],
          },
        ],
      },
      {
        path: 'thirdPartyGame',
        children: [
          { index: true, element: <ThirdPartyGame /> },
          { path: ':id', element: <ThirdPartyGame /> },
        ],
      },
      {
        path: 'casino',
        children: [
          { index: true, element: <CasinoWrapper /> },
          {
            element: <CasinoWrapper />,
            children: [
              { path: ':gameId', element: <GameDetails /> },
            ],
          },
        ],
      },
      {
        path: 'liveCasino',
        children: [
          { index: true, element: <LiveCasinoWrapper /> },
          {
            element: <LiveCasinoWrapper />,
            children: [{ path: ':gameId', element: <GameDetails /> }],
          },
        ],
      },
      {
        path: 'tournaments',
        children: [
          { index: true, element: <Tournaments /> },
          { path: ':id', element: <TournamentDetails /> },
        ],
      },
      {
        path: 'clientTransaction',
        element: <ClientTransactionLayout />,
        children: [
          { index: true, element: <ClientTransaction /> },
          { path: 'deposit', element: <ClientTransactionDeposit /> },
          { path: 'withdraw', element: <ClientTransactionWithdraw /> },
        ],
      },
      {
        path: 'admin/*',
        element: <AdminWrapper />,
      },
      {
        path: '*',
        element: <ErrorNotFoundPage />,
      },
    ],
  },
];
